jQuery(document).ready(function () {
  jQuery(".read-more").each(function (index, item) {
    jQuery(item)
      .find(".sf__btn")
      .on("click", function (event) {
        event.preventDefault();

        const child = jQuery(item).find(".sf-custom__block-inner");

        const divHeight = jQuery(item)
          .find(".sf-custom__block-inner > div")
          .height();

        if (jQuery(child).height() !== 200) {
          jQuery(child).animate({ height: "200px" }, 500);
          jQuery(child).find(".sf__btn").html("Viac na");
          jQuery(item).addClass("read-more-transparency");
        } else {
          jQuery(child).animate({ height: divHeight }, 500);
          jQuery(child).find(".sf__btn").html("Menej");
          jQuery(item).removeClass("read-more-transparency");
        }
      });
  });
});

/* Menu */
// Menu toggle
jQuery(document).ready(function() {
  const navToggle = jQuery('.nav-toggle');
  const menuToggle = jQuery('.menu-toggle');

  jQuery(document).on('click', function() {
    if (navToggle.hasClass('open')) {
      navToggle.removeClass('open');
      menuToggle.removeClass('active');
    }
  });

  navToggle.on('click', function(e) {
    navToggle.toggleClass('open');
    menuToggle.toggleClass('active');
    e.stopPropagation();
  });

  menuToggle.on('click', function(e) {
    e.stopPropagation();
  });
});

// Dropdown toggle
jQuery(document).ready(function() {
  const dropdownButton = jQuery('.dropdown .dropdown-button');

  dropdownButton.on('click', function(e) {
    jQuery(this).parent().next('ul').toggleClass('show');
    jQuery(this).parent().parent().toggleClass('active');
    e.stopPropagation();
  });
});

// Second level dropdown toggle
// jQuery(document).ready(function() {
//   const deepDropdownButton = jQuery('.dropdown.second-level .dropdown-button');

//   console.log('deepDropdownButton: ', deepDropdownButton);

//   // deepDropdownButton.on('click', function(e) {
//   //   jQuery(this).parent().next('ul').toggleClass('show');
//   //   jQuery(this).parent().parent().toggleClass('active');
//   //   e.stopPropagation();
//   // });
// });
/* /Menu */
